import { createContext } from "react";
import { contextFunctionInit } from "sprint-common-web";

import { OrderStatus } from "../../../common/types/OrderStatus";
import { defaultOrderDashboardItem, OrderDashboardItem } from "../OrderDashboardItem";

interface IOrderDashboardContext {
    isLoading: boolean;
    orderId: string;
    orderDashboardItem: OrderDashboardItem;
    status: OrderStatus;
    approveDelivery(): void;
    reject(): void;
    completeRejected(): void;
    areNotesLoading?: boolean;
}

const defaultOrderDashboardContext: IOrderDashboardContext = {
    isLoading: true,
    orderId: "",
    orderDashboardItem: defaultOrderDashboardItem,
    status: OrderStatus.Pending,
    approveDelivery: contextFunctionInit,
    reject: contextFunctionInit,
    completeRejected: contextFunctionInit,
    areNotesLoading: false
};

export const OrderDashboardContext = createContext<IOrderDashboardContext>(defaultOrderDashboardContext);
